<template>
  <div>
    <div class="center-t">
      <div class="sp-odt">入库申请记录查询</div>
    </div>
    <div class="page-wrap">
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column type="index" width="55" label="序号" align="center">
          <template slot-scope="scope">{{
            (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1
          }}</template>
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="企业名称"
          width="200"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="type"
          label="级别"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            $common.getTypeText(scope.row.type)
          }}</template>
        </el-table-column>

        <el-table-column
          prop="type"
          label="降级级别"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            $common.getTypeText(scope.row.backType)
          }}</template>
        </el-table-column>

        <el-table-column
          prop="actNodeName"
          label="流程状态"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="updateTime"
          label="最后更新日期"
          align="center"
          width="160"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            scope.row.updateTime ? scope.row.updateTime.split(" ")[0] : ""
          }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-view"
              @click="handleView(scope.row.id)"
              >查看</el-button
            >
            <el-button
              v-if="
                scope.row.actNodeKey == '00' &&
                scope.row.applyStatus == '0' &&
                (scope.row.actNodeName == '待提交' ||
                  scope.row.actNodeName == '被退回')
              "
              size="mini"
              type="text"
              icon="el-icon-d-arrow-right"
              @click="handleApply(scope.row.type)"
              >继续申报</el-button
            >
            <el-button
              v-if="
                scope.row.ipmGoldenSeedCompany != null &&
                scope.row.certStatus == 1 &&
                scope.row.ipmGoldenSeedCompany.status == 1
              "
              size="mini"
              type="text"
              icon="el-icon-download"
              @click="handleDownload(scope.row.id)"
              >下载证书</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>
<script>
import { applyHistory } from "@/api/index";
export default {
  data() {
    return {
      queryParams: {
        pageSize: 10,
        pageNum: 1,
      },
      tableData: [],
      id: "",
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      applyHistory({ ...this.queryParams }).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    },
    handleView(id) {
      window.open(`/jzz/applyView?id=${id}`);
    },
    handleApply(level) {
      window.open(`/jzz/apply?level=${level}`);
    },
    handleDownload(id) {
      window.open(
        process.env.VUE_APP_URL +
          "/goldenseed/application/ipmGoldenSeedCompany/downCert?id=" +
          id +
          "&access_token=" +
          localStorage.getItem("access_token"),
        "_blank"
      );
    },
  },
};
</script>
<style lang="less" scoped>
</style>